import React from 'react';
import { Button } from 'antd';
import useGetSettingsForPlan from '../../sales/hooks/useGetSettingsForPlan';
import { useFetchWebsiteIndexEntriesQuery } from './service';
import { useNavigate } from '../../router/hooks/useNavigate';

type Props = {
    style?: Record<string, string>;
};

export default function AddNewWebsiteButton({ style }: Props) {
    const navigation = useNavigate();

    const { data: websiteIndexEntries } = useFetchWebsiteIndexEntriesQuery();
    const { dp_max_domains: maximumWebsiteIndexEntries } = useGetSettingsForPlan();

    const handleAddNewDomainClicked = (event: React.MouseEvent<HTMLElement>) => {
        navigation('/deep-analysis/setup-domain');
        event.currentTarget.blur();
    };

    const showButton = !!maximumWebsiteIndexEntries && websiteIndexEntries && websiteIndexEntries.length < maximumWebsiteIndexEntries;

    return (
        <>
            {showButton && (
                <Button
                    style={style}
                    className="deep-analysis-small-button"
                    type="primary"
                    size="small"
                    onClick={handleAddNewDomainClicked}
                >
                    Add new domain
                </Button>
            )}
        </>
    );
}
